class QuickView extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)

    this.listeners.add(document, 'click', this.handleTrigger)
  }

  async handleTrigger (event) {
    const trigger = event.target.closest(
      '[data-quick-view-external-el="trigger"]',
    )

    if (!trigger) return

    await window.BAO.sectionRenderer
      .fetchSingle('quick-view', trigger.dataset.productUrl)
      .then((res) => {
        const newDOM = window.BAO.sectionRenderer.convertToDOM(res)

        const bodyContent = newDOM.querySelector('.drw-QuickView')

        this.els.body.element.innerHTML = bodyContent.outerHTML

        window.drawers.activeDrawerKey = 'quick-view'

        window.BAO.dispatchEvent(window.BAO.EVENTS.WISHLIST.CHECK_WISHLIST)
      })
      .catch(() => {
        window.drawers.activeDrawerKey = ''
      })
  }
}

if (!customElements.get('quick-view')) {
  customElements.define('quick-view', QuickView)
}
